import { useContext, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { get, put } from "@utils/axios_api";
import { toast } from "react-toastify";
import { AuthContext } from "@context";

const schema = yup.object().shape({
  name: yup.string().required("이름을 입력하세요."),
  password: yup.string(),
  phoneNo: yup.string(),
  email: yup
    .string()
    .test("email-format", "올바른 이메일 형식을 입력하세요.", (value) => {
      if (!value) return true;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }),
});

export function useMemberInfoLogic({ isOpen, onClose }) {
  const { updateProfile } = useContext(AuthContext);
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      id: "",
      name: "",
      password: "",
      phoneNo: "",
      email: "",
    },
    shouldFocusError: false,
  });

  const { reset, handleSubmit, setValue, control } = methods;

  const phoneNo = useWatch({ control, name: "phoneNo" });
  useEffect(() => {
    if (phoneNo && phoneNo.includes('-')) {
      setValue("phoneNo", phoneNo.replace(/\D/g, ''));
    }
  }, [phoneNo, setValue]);

  useEffect(() => {
    if (isOpen) {
      get("/user/member/memberInfo")
        .then((data) => {
          const result = data.result;
          reset({
            id: result.id || "",
            name: result.name || "",
            password: "",
            phoneNo: result.phoneNo || "",
            email: result.email || "",
          });
        })
        .catch((err) => {
          console.error("회원정보 불러오기 실패:", err);
        });
    } else {
      reset({
        id: "",
        name: "",
        phoneNo: "",
        email: "",
      });
    }
  }, [isOpen, reset]);


  const saveMember = async (formData) => {
    try {
      await put("/user/member/memberUpdate", formData);
      updateProfile({ name: formData.name });
      toast.success("회원 정보가 수정되었습니다.");
      onClose();
    } catch (err) {
      console.error("저장 실패:", err);
    }
  };
  const onSubmit = (formData) => {
    saveMember(formData);
  };

  const onError = () => {
    toast.error("필수 입력란을 확인하세요.");
  };


  return {
    ...methods,
    handleSubmit,
    onSubmit,
    onError,        

  };
}
